import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { adminAPI } from '../../../api';
import Pagination from '../../../components/Pagination';
import EditIcon from '../../../../../../assets/images/reskin-images/icon--edit.svg';
import BinIcon from '../../../../../../assets/images/reskin-images/icon--bin.svg';
import SVG from 'react-inlinesvg';
import DeleteModal from './components/DeleteModal';
import useModal from '../../../context/ModalContext';
import SimpleTable from '../../../components/SimpleTable';

const Companies = ({ searchQuery, setOpenSideActionBoard, setRefetchCompanies }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const { setContent } = useModal();

  const { data, refetch } = useQuery(
    ['getAllCompanies', { page: currentPage, search: searchQuery }],
    adminAPI.getAllCompanies
  );

  useEffect(() => {
    if (setRefetchCompanies) {
      setRefetchCompanies(refetch);
    }
  }, [refetch, setRefetchCompanies]);

  useEffect(() => {
    refetch();
  }, [currentPage, searchQuery, refetch]);

  const columns = [
    {
      label: 'Name',
      field: 'name',
      textAlign: 'left',
      fontWeight: 'semibold',
      width: '240px',
      onHover: (item) => (
        <div className={'flex h-full items-center gap-2'}>
          <button
            type="button"
            className="flex items-center justify-content-center bg-purple-100 p-2 rounded-lg hover:bg-purple-200"
            onClick={() => {
              setOpenSideActionBoard({
                type: 'companies',
                action: 'edit',
                ids: [item.id],
              });
            }}
          >
            <SVG src={EditIcon} />
          </button>
          <button
            type="button"
            className="flex items-center justify-content-center bg-purple-100 hover:bg-red-lighter rounded-lg p-2"
            onClick={() => {
              setContent({
                content: <DeleteModal id={item.id} refetch={refetch} />,
              });
            }}
          >
            <SVG src={BinIcon} />
          </button>
        </div>
      ),
    },
    {
      label: 'City',
      field: 'city',
      textAlign: 'left',
      fontWeight: 'semibold',
      width: '140px',
    },
    {
      label: 'State',
      field: 'state_name',
      textAlign: 'left',
      fontWeight: 'semibold',
      width: '120px',
    },
    {
      label: 'Country',
      field: 'country_name',
      textAlign: 'left',
      fontWeight: 'semibold',
      width: '150px',
    },
    {
      label: 'Phone',
      field: 'phone',
      textAlign: 'left',
      fontWeight: 'semibold',
      width: '150px',
    },
    {
      label: 'Cohorts Count',
      field: 'cohorts_count',
      textAlign: 'center',
      fontWeight: 'semibold',
      width: '120px',
    },
  ];

  const renderRowFn = (company) => {
    return {
      id: company.id,
      name: company.name,
      city: company.city || '-',
      state_name: company.state_name || '-',
      country_name: company.country_name || '-',
      phone: company.phone || '-',
      cohorts_count: company.cohorts_count ?? 0,
    };
  };

  return (
    <>
      {data?.companies && (
        <div>
          <SimpleTable data={data?.companies} columns={columns} rowFormatter={renderRowFn} />
        </div>
      )}

      <div style={{ paddingTop: 20 }}>
        <Pagination
          currentPage={currentPage}
          totalPage={data?.pagination?.total_pages}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
    </>
  );
};

export default Companies;
